import React from 'react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'
import Coin from 'components/Coin'
import Countdown from 'components/Countdown'
import GameCardScores from '../GameCardScores'

interface Props {
  entryFee: number
  firstPrize: number
  remainingSec: number
}

const styles = createStyles({
  value: {
    fontSize: 16,
    fontWeight: 500,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardScoresDefault: React.SFC<InjectedProps> = ({
  classes,
  entryFee,
  firstPrize,
  remainingSec,
}) => {
  // TODO: translation keys needed
  const days = Math.floor(remainingSec / 86400)

  return (
    <GameCardScores
      columns={[{
        value: (
          <Typography className={classes.value}>
            {
              days < 1
                ? (
                  <Countdown remainingSec={remainingSec} />
                ) : (
                  <T
                    id={days > 1 ? 'game_countdown_format_plural' : 'game_countdown_format_singular'}
                    values={{ d: days }}
                  />
                )
            }
          </Typography>
        ),
        label: (
          <T id="game_countdown" />
        ),
      }, {
        value: (
          <Coin className={classes.value} value={entryFee} />
        ),
        label: (
          <T id="game_entryfee" />
        )
      }, {
        value: (
          <Coin className={classes.value} value={firstPrize} />
        ),
        label: 'first prize',
      }]}
    />
  )
}

export default withStyles(styles)(GameCardScoresDefault)
